export const cityData = {
  "北海道": [
    "えりも町",
    "せたな町",
    "むかわ町",
    "ニセコ町",
    "七飯町",
    "三笠市",
    "上ノ国町",
    "上士幌町",
    "上富良野町",
    "上川町",
    "上砂川町",
    "下川町",
    "中富良野町",
    "中川町",
    "中札内村",
    "中標津町",
    "中頓別町",
    "乙部町",
    "京極町",
    "仁木町",
    "今金町",
    "伊達市",
    "佐呂間町",
    "余市町",
    "倶知安町",
    "八雲町",
    "共和町",
    "函館市",
    "初山別村",
    "別海町",
    "利尻富士町",
    "利尻町",
    "剣淵町",
    "北広島市",
    "北斗市",
    "北竜町",
    "北見市",
    "千歳市",
    "南富良野町",
    "南幌町",
    "占冠村",
    "厚岸町",
    "厚沢部町",
    "厚真町",
    "古平町",
    "名寄市",
    "和寒町",
    "喜茂別町",
    "増毛町",
    "士別市",
    "士幌町",
    "壮瞥町",
    "夕張市",
    "大樹町",
    "大空町",
    "天塩町",
    "奈井江町",
    "奥尻町",
    "妹背牛町",
    "安平町",
    "室蘭市",
    "富良野市",
    "寿都町",
    "小平町",
    "小樽市",
    "小清水町",
    "岩内町",
    "岩見沢市",
    "島牧村",
    "帯広市",
    "幌加内町",
    "幌延町",
    "幕別町",
    "平取町",
    "広尾町",
    "弟子屈町",
    "当別町",
    "当麻町",
    "恵庭市",
    "愛別町",
    "斜里町",
    "新ひだか町",
    "新冠町",
    "新十津川町",
    "新得町",
    "新篠津村",
    "日高町",
    "旭川市",
    "更別村",
    "月形町",
    "木古内町",
    "本別町",
    "札幌市",
    "東川町",
    "東神楽町",
    "松前町",
    "枝幸町",
    "栗山町",
    "根室市",
    "森町",
    "様似町",
    "標津町",
    "標茶町",
    "歌志内市",
    "比布町",
    "江別市",
    "江差町",
    "池田町",
    "沼田町",
    "泊村",
    "洞爺湖町",
    "津別町",
    "浜中町",
    "浜頓別町",
    "浦幌町",
    "浦河町",
    "浦臼町",
    "深川市",
    "清水町",
    "清里町",
    "湧別町",
    "滝上町",
    "滝川市",
    "猿払村",
    "由仁町",
    "留別村",
    "留夜別村",
    "留寿都村",
    "留萌市",
    "登別市",
    "白糠町",
    "白老町",
    "真狩村",
    "知内町",
    "石狩市",
    "砂川市",
    "礼文町",
    "神恵内村",
    "福島町",
    "秩父別町",
    "稚内市",
    "積丹町",
    "紋別市",
    "紗那村",
    "網走市",
    "置戸町",
    "羅臼町",
    "美唄市",
    "美幌町",
    "美深町",
    "美瑛町",
    "羽幌町",
    "興部町",
    "色丹村",
    "芦別市",
    "芽室町",
    "苫前町",
    "苫小牧市",
    "蘂取村",
    "蘭越町",
    "西興部村",
    "訓子府町",
    "豊富町",
    "豊浦町",
    "豊頃町",
    "赤井川村",
    "赤平市",
    "足寄町",
    "遠別町",
    "遠軽町",
    "釧路市",
    "釧路町",
    "長万部町",
    "長沼町",
    "陸別町",
    "雄武町",
    "雨竜町",
    "音威子府村",
    "音更町",
    "鶴居村",
    "鷹栖町",
    "鹿追町",
    "鹿部町",
    "黒松内町"
  ],
  "青森県": [
    "おいらせ町",
    "つがる市",
    "むつ市",
    "七戸町",
    "三戸町",
    "三沢市",
    "中泊町",
    "五戸町",
    "五所川原市",
    "今別町",
    "佐井村",
    "八戸市",
    "六ヶ所村",
    "六戸町",
    "十和田市",
    "南部町",
    "外ヶ浜町",
    "大間町",
    "大鰐町",
    "平内町",
    "平川市",
    "弘前市",
    "新郷村",
    "東北町",
    "東通村",
    "板柳町",
    "横浜町",
    "深浦町",
    "田子町",
    "田舎館村",
    "蓬田村",
    "藤崎町",
    "西目屋村",
    "野辺地町",
    "階上町",
    "青森市",
    "風間浦村",
    "鰺ヶ沢町",
    "鶴田町",
    "黒石市"
  ],
  "岩手県": [
    "一戸町",
    "一関市",
    "久慈市",
    "九戸村",
    "二戸市",
    "住田町",
    "八幡平市",
    "北上市",
    "大槌町",
    "大船渡市",
    "奥州市",
    "宮古市",
    "山田町",
    "岩手町",
    "岩泉町",
    "平泉町",
    "普代村",
    "洋野町",
    "滝沢市",
    "田野畑村",
    "盛岡市",
    "矢巾町",
    "紫波町",
    "花巻市",
    "葛巻町",
    "西和賀町",
    "軽米町",
    "遠野市",
    "野田村",
    "金ケ崎町",
    "釜石市",
    "陸前高田市",
    "雫石町"
  ],
  "宮城県": [
    "七ヶ宿町",
    "七ヶ浜町",
    "丸森町",
    "亘理町",
    "仙台市",
    "利府町",
    "加美町",
    "南三陸町",
    "名取市",
    "塩竈市",
    "多賀城市",
    "大和町",
    "大崎市",
    "大河原町",
    "大衡村",
    "大郷町",
    "女川町",
    "富谷市",
    "山元町",
    "岩沼市",
    "川崎町",
    "村田町",
    "東松島市",
    "松島町",
    "柴田町",
    "栗原市",
    "気仙沼市",
    "涌谷町",
    "登米市",
    "白石市",
    "石巻市",
    "美里町",
    "色麻町",
    "蔵王町",
    "角田市"
  ],
  "秋田県": [
    "にかほ市",
    "三種町",
    "上小阿仁村",
    "五城目町",
    "井川町",
    "仙北市",
    "八峰町",
    "八郎潟町",
    "北秋田市",
    "大仙市",
    "大潟村",
    "大館市",
    "小坂町",
    "東成瀬村",
    "横手市",
    "湯沢市",
    "潟上市",
    "由利本荘市",
    "男鹿市",
    "秋田市",
    "美郷町",
    "羽後町",
    "能代市",
    "藤里町",
    "鹿角市"
  ],
  "山形県": [
    "三川町",
    "上山市",
    "中山町",
    "南陽市",
    "大江町",
    "大石田町",
    "大蔵村",
    "天童市",
    "寒河江市",
    "小国町",
    "尾花沢市",
    "山形市",
    "山辺町",
    "川西町",
    "庄内町",
    "戸沢村",
    "新庄市",
    "最上町",
    "朝日町",
    "村山市",
    "東根市",
    "河北町",
    "白鷹町",
    "真室川町",
    "米沢市",
    "舟形町",
    "西川町",
    "遊佐町",
    "酒田市",
    "金山町",
    "長井市",
    "飯豊町",
    "高畠町",
    "鮭川村",
    "鶴岡市"
  ],
  "福島県": [
    "いわき市",
    "三島町",
    "三春町",
    "下郷町",
    "中島村",
    "二本松市",
    "伊達市",
    "会津坂下町",
    "会津美里町",
    "会津若松市",
    "北塩原村",
    "南会津町",
    "南相馬市",
    "双葉町",
    "古殿町",
    "只見町",
    "喜多方市",
    "国見町",
    "塙町",
    "大熊町",
    "大玉村",
    "天栄村",
    "富岡町",
    "小野町",
    "川俣町",
    "川内村",
    "平田村",
    "広野町",
    "新地町",
    "昭和村",
    "本宮市",
    "柳津町",
    "桑折町",
    "棚倉町",
    "楢葉町",
    "檜枝岐村",
    "泉崎村",
    "浅川町",
    "浪江町",
    "湯川村",
    "猪苗代町",
    "玉川村",
    "田村市",
    "白河市",
    "相馬市",
    "矢吹町",
    "矢祭町",
    "石川町",
    "磐梯町",
    "福島市",
    "葛尾村",
    "西会津町",
    "西郷村",
    "郡山市",
    "金山町",
    "鏡石町",
    "須賀川市",
    "飯舘村",
    "鮫川村"
  ],
  "茨城県": [
    "かすみがうら市",
    "つくばみらい市",
    "つくば市",
    "ひたちなか市",
    "下妻市",
    "五霞町",
    "八千代町",
    "利根町",
    "北茨城市",
    "取手市",
    "古河市",
    "土浦市",
    "坂東市",
    "城里町",
    "境町",
    "大子町",
    "大洗町",
    "守谷市",
    "小美玉市",
    "常総市",
    "常陸大宮市",
    "常陸太田市",
    "日立市",
    "東海村",
    "桜川市",
    "水戸市",
    "河内町",
    "潮来市",
    "牛久市",
    "石岡市",
    "神栖市",
    "稲敷市",
    "笠間市",
    "筑西市",
    "結城市",
    "美浦村",
    "茨城町",
    "行方市",
    "那珂市",
    "鉾田市",
    "阿見町",
    "高萩市",
    "鹿嶋市",
    "龍ケ崎市"
  ],
  "栃木県": [
    "さくら市",
    "上三川町",
    "下野市",
    "佐野市",
    "塩谷町",
    "壬生町",
    "大田原市",
    "宇都宮市",
    "小山市",
    "市貝町",
    "日光市",
    "栃木市",
    "益子町",
    "真岡市",
    "矢板市",
    "芳賀町",
    "茂木町",
    "足利市",
    "那珂川町",
    "那須塩原市",
    "那須烏山市",
    "那須町",
    "野木町",
    "高根沢町",
    "鹿沼市"
  ],
  "群馬県": [
    "みどり市",
    "みなかみ町",
    "上野村",
    "下仁田町",
    "中之条町",
    "伊勢崎市",
    "前橋市",
    "千代田町",
    "南牧村",
    "吉岡町",
    "大泉町",
    "太田市",
    "嬬恋村",
    "安中市",
    "富岡市",
    "川場村",
    "明和町",
    "昭和村",
    "東吾妻町",
    "板倉町",
    "桐生市",
    "榛東村",
    "沼田市",
    "渋川市",
    "片品村",
    "玉村町",
    "甘楽町",
    "神流町",
    "草津町",
    "藤岡市",
    "邑楽町",
    "長野原町",
    "館林市",
    "高山村",
    "高崎市"
  ],
  "埼玉県": [
    "さいたま市",
    "ときがわ町",
    "ふじみ野市",
    "三芳町",
    "三郷市",
    "上尾市",
    "上里町",
    "久喜市",
    "伊奈町",
    "入間市",
    "八潮市",
    "加須市",
    "北本市",
    "吉川市",
    "吉見町",
    "和光市",
    "坂戸市",
    "宮代町",
    "寄居町",
    "富士見市",
    "小川町",
    "小鹿野町",
    "嵐山町",
    "川口市",
    "川島町",
    "川越市",
    "幸手市",
    "志木市",
    "戸田市",
    "所沢市",
    "新座市",
    "日高市",
    "春日部市",
    "朝霞市",
    "本庄市",
    "杉戸町",
    "東松山市",
    "東秩父村",
    "松伏町",
    "桶川市",
    "横瀬町",
    "毛呂山町",
    "深谷市",
    "滑川町",
    "熊谷市",
    "狭山市",
    "白岡市",
    "皆野町",
    "神川町",
    "秩父市",
    "美里町",
    "羽生市",
    "草加市",
    "蓮田市",
    "蕨市",
    "行田市",
    "越生町",
    "越谷市",
    "長瀞町",
    "飯能市",
    "鳩山町",
    "鴻巣市",
    "鶴ヶ島市"
  ],
  "千葉県": [
    "いすみ市",
    "一宮町",
    "九十九里町",
    "佐倉市",
    "八千代市",
    "八街市",
    "勝浦市",
    "匝瑳市",
    "千葉市",
    "南房総市",
    "印西市",
    "君津市",
    "四街道市",
    "多古町",
    "大多喜町",
    "大網白里市",
    "富津市",
    "富里市",
    "山武市",
    "市原市",
    "市川市",
    "御宿町",
    "成田市",
    "我孫子市",
    "旭市",
    "木更津市",
    "東庄町",
    "東金市",
    "松戸市",
    "柏市",
    "栄町",
    "横芝光町",
    "流山市",
    "浦安市",
    "白井市",
    "白子町",
    "睦沢町",
    "神崎町",
    "習志野市",
    "船橋市",
    "芝山町",
    "茂原市",
    "袖ケ浦市",
    "酒々井町",
    "野田市",
    "銚子市",
    "鋸南町",
    "鎌ケ谷市",
    "長南町",
    "長柄町",
    "長生村",
    "館山市",
    "香取市",
    "鴨川市"
  ],
  "東京都": [
    "あきる野市",
    "三宅村",
    "三鷹市",
    "世田谷区",
    "中央区",
    "中野区",
    "八丈町",
    "八王子市",
    "利島村",
    "北区",
    "千代田区",
    "台東区",
    "品川区",
    "国分寺市",
    "国立市",
    "墨田区",
    "多摩市",
    "大島町",
    "大田区",
    "奥多摩町",
    "小平市",
    "小笠原村",
    "小金井市",
    "府中市",
    "御蔵島村",
    "文京区",
    "新宿区",
    "新島村",
    "日の出町",
    "日野市",
    "昭島市",
    "杉並区",
    "東久留米市",
    "東大和市",
    "東村山市",
    "板橋区",
    "檜原村",
    "武蔵村山市",
    "武蔵野市",
    "江戸川区",
    "江東区",
    "清瀬市",
    "渋谷区",
    "港区",
    "狛江市",
    "瑞穂町",
    "町田市",
    "目黒区",
    "神津島村",
    "福生市",
    "稲城市",
    "立川市",
    "練馬区",
    "羽村市",
    "荒川区",
    "葛飾区",
    "西東京市",
    "調布市",
    "豊島区",
    "足立区",
    "青ヶ島村",
    "青梅市"
  ],
  "神奈川県": [
    "三浦市",
    "中井町",
    "二宮町",
    "伊勢原市",
    "南足柄市",
    "厚木市",
    "大井町",
    "大和市",
    "大磯町",
    "寒川町",
    "小田原市",
    "山北町",
    "川崎市",
    "平塚市",
    "座間市",
    "愛川町",
    "松田町",
    "横浜市",
    "横須賀市",
    "海老名市",
    "清川村",
    "湯河原町",
    "相模原市",
    "真鶴町",
    "秦野市",
    "箱根町",
    "綾瀬市",
    "茅ヶ崎市",
    "葉山町",
    "藤沢市",
    "逗子市",
    "鎌倉市",
    "開成町"
  ],
  "新潟県": [
    "三条市",
    "上越市",
    "五泉市",
    "佐渡市",
    "出雲崎町",
    "刈羽村",
    "加茂市",
    "十日町市",
    "南魚沼市",
    "妙高市",
    "小千谷市",
    "弥彦村",
    "新潟市",
    "新発田市",
    "村上市",
    "柏崎市",
    "津南町",
    "湯沢町",
    "燕市",
    "田上町",
    "粟島浦村",
    "糸魚川市",
    "聖籠町",
    "胎内市",
    "見附市",
    "長岡市",
    "関川村",
    "阿賀町",
    "阿賀野市",
    "魚沼市"
  ],
  "富山県": [
    "上市町",
    "入善町",
    "南砺市",
    "富山市",
    "射水市",
    "小矢部市",
    "朝日町",
    "氷見市",
    "滑川市",
    "砺波市",
    "立山町",
    "舟橋村",
    "高岡市",
    "魚津市",
    "黒部市"
  ],
  "石川県": [
    "かほく市",
    "七尾市",
    "中能登町",
    "内灘町",
    "加賀市",
    "宝達志水町",
    "小松市",
    "川北町",
    "志賀町",
    "津幡町",
    "珠洲市",
    "白山市",
    "穴水町",
    "羽咋市",
    "能登町",
    "能美市",
    "輪島市",
    "野々市市",
    "金沢市"
  ],
  "福井県": [
    "あわら市",
    "おおい町",
    "勝山市",
    "南越前町",
    "坂井市",
    "大野市",
    "小浜市",
    "敦賀市",
    "永平寺町",
    "池田町",
    "福井市",
    "美浜町",
    "若狭町",
    "越前市",
    "越前町",
    "高浜町",
    "鯖江市"
  ],
  "山梨県": [
    "上野原市",
    "中央市",
    "丹波山村",
    "北杜市",
    "南アルプス市",
    "南部町",
    "大月市",
    "富士吉田市",
    "富士川町",
    "富士河口湖町",
    "小菅村",
    "山中湖村",
    "山梨市",
    "市川三郷町",
    "忍野村",
    "早川町",
    "昭和町",
    "甲州市",
    "甲府市",
    "甲斐市",
    "笛吹市",
    "西桂町",
    "身延町",
    "道志村",
    "都留市",
    "韮崎市",
    "鳴沢村"
  ],
  "長野県": [
    "上松町",
    "上田市",
    "下條村",
    "下諏訪町",
    "中川村",
    "中野市",
    "伊那市",
    "佐久市",
    "佐久穂町",
    "信濃町",
    "北相木村",
    "千曲市",
    "南木曽町",
    "南牧村",
    "南相木村",
    "南箕輪村",
    "原村",
    "喬木村",
    "坂城町",
    "塩尻市",
    "売木村",
    "大桑村",
    "大町市",
    "大鹿村",
    "天龍村",
    "安曇野市",
    "宮田村",
    "富士見町",
    "小川村",
    "小布施町",
    "小海町",
    "小諸市",
    "小谷村",
    "山ノ内町",
    "山形村",
    "岡谷市",
    "川上村",
    "平谷村",
    "御代田町",
    "朝日村",
    "木島平村",
    "木曽町",
    "木祖村",
    "東御市",
    "松川村",
    "松川町",
    "松本市",
    "栄村",
    "根羽村",
    "池田町",
    "泰阜村",
    "王滝村",
    "生坂村",
    "白馬村",
    "立科町",
    "筑北村",
    "箕輪町",
    "茅野市",
    "諏訪市",
    "豊丘村",
    "軽井沢町",
    "辰野町",
    "野沢温泉村",
    "長和町",
    "長野市",
    "阿南町",
    "阿智村",
    "青木村",
    "須坂市",
    "飯山市",
    "飯島町",
    "飯田市",
    "飯綱町",
    "駒ヶ根市",
    "高山村",
    "高森町",
    "麻績村"
  ],
  "岐阜県": [
    "七宗町",
    "下呂市",
    "中津川市",
    "八百津町",
    "北方町",
    "可児市",
    "各務原市",
    "土岐市",
    "坂祝町",
    "垂井町",
    "多治見市",
    "大垣市",
    "大野町",
    "安八町",
    "富加町",
    "山県市",
    "岐南町",
    "岐阜市",
    "川辺町",
    "御嵩町",
    "恵那市",
    "揖斐川町",
    "本巣市",
    "東白川村",
    "池田町",
    "海津市",
    "瑞浪市",
    "瑞穂市",
    "白川村",
    "白川町",
    "神戸町",
    "笠松町",
    "美濃加茂市",
    "美濃市",
    "羽島市",
    "輪之内町",
    "郡上市",
    "関ケ原町",
    "関市",
    "飛騨市",
    "養老町",
    "高山市"
  ],
  "静岡県": [
    "三島市",
    "下田市",
    "伊東市",
    "伊豆の国市",
    "伊豆市",
    "函南町",
    "南伊豆町",
    "吉田町",
    "富士宮市",
    "富士市",
    "小山町",
    "島田市",
    "川根本町",
    "御前崎市",
    "御殿場市",
    "掛川市",
    "東伊豆町",
    "松崎町",
    "森町",
    "河津町",
    "沼津市",
    "浜松市",
    "清水町",
    "湖西市",
    "焼津市",
    "熱海市",
    "牧之原市",
    "磐田市",
    "菊川市",
    "藤枝市",
    "袋井市",
    "裾野市",
    "西伊豆町",
    "長泉町",
    "静岡市"
  ],
  "愛知県": [
    "あま市",
    "みよし市",
    "一宮市",
    "刈谷市",
    "北名古屋市",
    "半田市",
    "南知多町",
    "名古屋市",
    "大口町",
    "大府市",
    "大治町",
    "安城市",
    "小牧市",
    "尾張旭市",
    "岡崎市",
    "岩倉市",
    "常滑市",
    "幸田町",
    "弥富市",
    "愛西市",
    "扶桑町",
    "新城市",
    "日進市",
    "春日井市",
    "東栄町",
    "東浦町",
    "東海市",
    "東郷町",
    "武豊町",
    "江南市",
    "津島市",
    "清須市",
    "瀬戸市",
    "犬山市",
    "田原市",
    "知多市",
    "知立市",
    "碧南市",
    "稲沢市",
    "美浜町",
    "蒲郡市",
    "蟹江町",
    "西尾市",
    "設楽町",
    "豊山町",
    "豊川市",
    "豊明市",
    "豊根村",
    "豊橋市",
    "豊田市",
    "長久手市",
    "阿久比町",
    "飛島村",
    "高浜市"
  ],
  "三重県": [
    "いなべ市",
    "亀山市",
    "伊勢市",
    "伊賀市",
    "南伊勢町",
    "名張市",
    "四日市市",
    "多気町",
    "大台町",
    "大紀町",
    "尾鷲市",
    "川越町",
    "度会町",
    "御浜町",
    "志摩市",
    "明和町",
    "朝日町",
    "木曽岬町",
    "東員町",
    "松阪市",
    "桑名市",
    "津市",
    "熊野市",
    "玉城町",
    "紀北町",
    "紀宝町",
    "菰野町",
    "鈴鹿市",
    "鳥羽市"
  ],
  "滋賀県": [
    "多賀町",
    "大津市",
    "守山市",
    "彦根市",
    "愛荘町",
    "日野町",
    "東近江市",
    "栗東市",
    "湖南市",
    "甲良町",
    "甲賀市",
    "竜王町",
    "米原市",
    "草津市",
    "豊郷町",
    "近江八幡市",
    "野洲市",
    "長浜市",
    "高島市"
  ],
  "京都府": [
    "与謝野町",
    "久御山町",
    "亀岡市",
    "井手町",
    "京丹後市",
    "京丹波町",
    "京田辺市",
    "京都市",
    "伊根町",
    "八幡市",
    "南丹市",
    "南山城村",
    "向日市",
    "和束町",
    "城陽市",
    "大山崎町",
    "宇治市",
    "宇治田原町",
    "宮津市",
    "木津川市",
    "福知山市",
    "笠置町",
    "精華町",
    "綾部市",
    "舞鶴市",
    "長岡京市"
  ],
  "大阪府": [
    "交野市",
    "八尾市",
    "千早赤阪村",
    "吹田市",
    "和泉市",
    "四條畷市",
    "堺市",
    "大東市",
    "大阪市",
    "大阪狭山市",
    "太子町",
    "守口市",
    "富田林市",
    "寝屋川市",
    "岬町",
    "岸和田市",
    "島本町",
    "忠岡町",
    "摂津市",
    "東大阪市",
    "松原市",
    "枚方市",
    "柏原市",
    "池田市",
    "河内長野市",
    "河南町",
    "泉佐野市",
    "泉南市",
    "泉大津市",
    "熊取町",
    "田尻町",
    "箕面市",
    "羽曳野市",
    "能勢町",
    "茨木市",
    "藤井寺市",
    "豊中市",
    "豊能町",
    "貝塚市",
    "門真市",
    "阪南市",
    "高槻市",
    "高石市"
  ],
  "兵庫県": [
    "たつの市",
    "三木市",
    "三田市",
    "上郡町",
    "丹波市",
    "丹波篠山市",
    "伊丹市",
    "佐用町",
    "加古川市",
    "加東市",
    "加西市",
    "南あわじ市",
    "多可町",
    "太子町",
    "姫路市",
    "宍粟市",
    "宝塚市",
    "小野市",
    "尼崎市",
    "川西市",
    "市川町",
    "播磨町",
    "新温泉町",
    "明石市",
    "朝来市",
    "洲本市",
    "淡路市",
    "猪名川町",
    "相生市",
    "神戸市",
    "神河町",
    "福崎町",
    "稲美町",
    "芦屋市",
    "西宮市",
    "西脇市",
    "豊岡市",
    "赤穂市",
    "養父市",
    "香美町",
    "高砂市"
  ],
  "奈良県": [
    "三宅町",
    "三郷町",
    "上北山村",
    "上牧町",
    "下北山村",
    "下市町",
    "五條市",
    "十津川村",
    "吉野町",
    "大和郡山市",
    "大和高田市",
    "大淀町",
    "天川村",
    "天理市",
    "奈良市",
    "宇陀市",
    "安堵町",
    "山添村",
    "川上村",
    "川西町",
    "平群町",
    "広陵町",
    "御所市",
    "御杖村",
    "斑鳩町",
    "明日香村",
    "曽爾村",
    "東吉野村",
    "桜井市",
    "橿原市",
    "河合町",
    "王寺町",
    "生駒市",
    "田原本町",
    "葛城市",
    "野迫川村",
    "香芝市",
    "高取町",
    "黒滝村"
  ],
  "和歌山県": [
    "かつらぎ町",
    "すさみ町",
    "みなべ町",
    "上富田町",
    "串本町",
    "九度山町",
    "北山村",
    "印南町",
    "古座川町",
    "和歌山市",
    "太地町",
    "岩出市",
    "広川町",
    "御坊市",
    "新宮市",
    "日高川町",
    "日高町",
    "有田川町",
    "有田市",
    "橋本市",
    "海南市",
    "湯浅町",
    "田辺市",
    "由良町",
    "白浜町",
    "紀の川市",
    "紀美野町",
    "美浜町",
    "那智勝浦町",
    "高野町"
  ],
  "鳥取県": [
    "三朝町",
    "伯耆町",
    "倉吉市",
    "八頭町",
    "北栄町",
    "南部町",
    "境港市",
    "大山町",
    "岩美町",
    "日南町",
    "日吉津村",
    "日野町",
    "智頭町",
    "江府町",
    "湯梨浜町",
    "琴浦町",
    "米子市",
    "若桜町",
    "鳥取市"
  ],
  "島根県": [
    "出雲市",
    "吉賀町",
    "大田市",
    "奥出雲町",
    "安来市",
    "川本町",
    "松江市",
    "江津市",
    "津和野町",
    "浜田市",
    "海士町",
    "益田市",
    "知夫村",
    "美郷町",
    "西ノ島町",
    "邑南町",
    "隠岐の島町",
    "雲南市",
    "飯南町"
  ],
  "岡山県": [
    "久米南町",
    "井原市",
    "倉敷市",
    "備前市",
    "勝央町",
    "吉備中央町",
    "和気町",
    "奈義町",
    "岡山市",
    "新庄村",
    "新見市",
    "早島町",
    "津山市",
    "浅口市",
    "瀬戸内市",
    "玉野市",
    "真庭市",
    "矢掛町",
    "笠岡市",
    "総社市",
    "美作市",
    "美咲町",
    "西粟倉村",
    "赤磐市",
    "里庄町",
    "鏡野町",
    "高梁市"
  ],
  "広島県": [
    "三原市",
    "三次市",
    "世羅町",
    "北広島町",
    "呉市",
    "坂町",
    "大崎上島町",
    "大竹市",
    "安芸太田町",
    "安芸高田市",
    "尾道市",
    "広島市",
    "庄原市",
    "府中市",
    "府中町",
    "廿日市市",
    "東広島市",
    "江田島市",
    "海田町",
    "熊野町",
    "神石高原町",
    "福山市",
    "竹原市"
  ],
  "山口県": [
    "上関町",
    "下松市",
    "下関市",
    "光市",
    "周南市",
    "周防大島町",
    "和木町",
    "宇部市",
    "山口市",
    "山陽小野田市",
    "岩国市",
    "平生町",
    "柳井市",
    "田布施町",
    "美祢市",
    "萩市",
    "長門市",
    "防府市",
    "阿武町"
  ],
  "徳島県": [
    "つるぎ町",
    "三好市",
    "上勝町",
    "上板町",
    "佐那河内村",
    "勝浦町",
    "北島町",
    "吉野川市",
    "小松島市",
    "徳島市",
    "東みよし町",
    "松茂町",
    "板野町",
    "海陽町",
    "牟岐町",
    "石井町",
    "神山町",
    "美波町",
    "美馬市",
    "藍住町",
    "那賀町",
    "阿南市",
    "阿波市",
    "鳴門市"
  ],
  "香川県": [
    "さぬき市",
    "まんのう町",
    "三木町",
    "三豊市",
    "丸亀市",
    "善通寺市",
    "土庄町",
    "坂出市",
    "多度津町",
    "宇多津町",
    "小豆島町",
    "東かがわ市",
    "琴平町",
    "直島町",
    "綾川町",
    "観音寺市",
    "高松市"
  ],
  "愛媛県": [
    "上島町",
    "久万高原町",
    "今治市",
    "伊予市",
    "伊方町",
    "八幡浜市",
    "内子町",
    "四国中央市",
    "大洲市",
    "宇和島市",
    "愛南町",
    "新居浜市",
    "東温市",
    "松前町",
    "松山市",
    "松野町",
    "砥部町",
    "西予市",
    "西条市",
    "鬼北町"
  ],
  "高知県": [
    "いの町",
    "三原村",
    "中土佐町",
    "仁淀川町",
    "佐川町",
    "北川村",
    "南国市",
    "四万十市",
    "四万十町",
    "土佐市",
    "土佐清水市",
    "土佐町",
    "大川村",
    "大月町",
    "大豊町",
    "奈半利町",
    "安田町",
    "安芸市",
    "室戸市",
    "宿毛市",
    "日高村",
    "本山町",
    "東洋町",
    "梼原町",
    "津野町",
    "田野町",
    "芸西村",
    "越知町",
    "須崎市",
    "香南市",
    "香美市",
    "馬路村",
    "高知市",
    "黒潮町"
  ],
  "福岡県": [
    "うきは市",
    "みやこ町",
    "みやま市",
    "上毛町",
    "中間市",
    "久山町",
    "久留米市",
    "八女市",
    "北九州市",
    "古賀市",
    "吉富町",
    "嘉麻市",
    "大任町",
    "大刀洗町",
    "大川市",
    "大木町",
    "大牟田市",
    "大野城市",
    "太宰府市",
    "宇美町",
    "宗像市",
    "宮若市",
    "小竹町",
    "小郡市",
    "岡垣町",
    "川崎町",
    "広川町",
    "志免町",
    "新宮町",
    "春日市",
    "朝倉市",
    "東峰村",
    "柳川市",
    "桂川町",
    "水巻町",
    "添田町",
    "田川市",
    "直方市",
    "福岡市",
    "福智町",
    "福津市",
    "筑前町",
    "筑後市",
    "筑紫野市",
    "築上町",
    "篠栗町",
    "粕屋町",
    "糸島市",
    "糸田町",
    "芦屋町",
    "苅田町",
    "行橋市",
    "豊前市",
    "赤村",
    "遠賀町",
    "那珂川市",
    "鞍手町",
    "須恵町",
    "飯塚市",
    "香春町"
  ],
  "佐賀県": [
    "みやき町",
    "上峰町",
    "伊万里市",
    "佐賀市",
    "吉野ヶ里町",
    "唐津市",
    "基山町",
    "多久市",
    "大町町",
    "太良町",
    "嬉野市",
    "小城市",
    "有田町",
    "武雄市",
    "江北町",
    "玄海町",
    "白石町",
    "神埼市",
    "鳥栖市",
    "鹿島市"
  ],
  "長崎県": [
    "五島市",
    "佐々町",
    "佐世保市",
    "南島原市",
    "壱岐市",
    "大村市",
    "対馬市",
    "小値賀町",
    "島原市",
    "川棚町",
    "平戸市",
    "新上五島町",
    "時津町",
    "東彼杵町",
    "松浦市",
    "波佐見町",
    "西海市",
    "諫早市",
    "長与町",
    "長崎市",
    "雲仙市"
  ],
  "熊本県": [
    "あさぎり町",
    "上天草市",
    "五木村",
    "人吉市",
    "八代市",
    "南小国町",
    "南関町",
    "南阿蘇村",
    "合志市",
    "和水町",
    "嘉島町",
    "多良木町",
    "大津町",
    "天草市",
    "宇土市",
    "宇城市",
    "小国町",
    "山江村",
    "山都町",
    "山鹿市",
    "御船町",
    "水上村",
    "水俣市",
    "氷川町",
    "津奈木町",
    "湯前町",
    "熊本市",
    "玉名市",
    "玉東町",
    "球磨村",
    "産山村",
    "甲佐町",
    "益城町",
    "相良村",
    "美里町",
    "芦北町",
    "苓北町",
    "荒尾市",
    "菊池市",
    "菊陽町",
    "西原村",
    "錦町",
    "長洲町",
    "阿蘇市",
    "高森町"
  ],
  "大分県": [
    "中津市",
    "九重町",
    "佐伯市",
    "別府市",
    "国東市",
    "大分市",
    "姫島村",
    "宇佐市",
    "日出町",
    "日田市",
    "杵築市",
    "津久見市",
    "玖珠町",
    "由布市",
    "竹田市",
    "臼杵市",
    "豊後大野市",
    "豊後高田市"
  ],
  "宮崎県": [
    "えびの市",
    "三股町",
    "串間市",
    "五ヶ瀬町",
    "国富町",
    "宮崎市",
    "小林市",
    "川南町",
    "延岡市",
    "新富町",
    "日之影町",
    "日南市",
    "日向市",
    "木城町",
    "椎葉村",
    "綾町",
    "美郷町",
    "西米良村",
    "西都市",
    "諸塚村",
    "都城市",
    "都農町",
    "門川町",
    "高千穂町",
    "高原町",
    "高鍋町"
  ],
  "鹿児島県": [
    "いちき串木野市",
    "さつま町",
    "三島村",
    "与論町",
    "中種子町",
    "伊仙町",
    "伊佐市",
    "出水市",
    "十島村",
    "南さつま市",
    "南九州市",
    "南大隅町",
    "南種子町",
    "和泊町",
    "喜界町",
    "垂水市",
    "大和村",
    "大崎町",
    "天城町",
    "奄美市",
    "姶良市",
    "宇検村",
    "屋久島町",
    "徳之島町",
    "志布志市",
    "指宿市",
    "日置市",
    "曽於市",
    "東串良町",
    "枕崎市",
    "湧水町",
    "瀬戸内町",
    "知名町",
    "肝付町",
    "薩摩川内市",
    "西之表市",
    "錦江町",
    "長島町",
    "阿久根市",
    "霧島市",
    "鹿児島市",
    "鹿屋市",
    "龍郷町"
  ],
  "沖縄県": [
    "うるま市",
    "与那原町",
    "与那国町",
    "中城村",
    "久米島町",
    "今帰仁村",
    "伊平屋村",
    "伊是名村",
    "伊江村",
    "八重瀬町",
    "北中城村",
    "北大東村",
    "北谷町",
    "南城市",
    "南大東村",
    "南風原町",
    "名護市",
    "嘉手納町",
    "国頭村",
    "多良間村",
    "大宜味村",
    "宜野座村",
    "宜野湾市",
    "宮古島市",
    "座間味村",
    "恩納村",
    "本部町",
    "東村",
    "沖縄市",
    "浦添市",
    "渡名喜村",
    "渡嘉敷村",
    "石垣市",
    "竹富町",
    "粟国村",
    "糸満市",
    "西原町",
    "読谷村",
    "豊見城市",
    "那覇市",
    "金武町"
  ]
};